<label (click)="show.half = !show.half"><fa-icon [icon]="show.half ? fa.checked : fa.unchecked"></fa-icon>Half steps</label>

<label (click)="show.maj = !show.maj"><fa-icon [icon]="show.maj ? fa.checked : fa.unchecked"></fa-icon>Major</label>
<label (click)="show.min = !show.min"><fa-icon [icon]="show.min ? fa.checked : fa.unchecked"></fa-icon>Minor</label>

<label (click)="show.guitar = !show.guitar"><fa-icon [icon]="show.guitar ? fa.checked : fa.unchecked"></fa-icon>Guitar</label>
<label (click)="show.ukulele = !show.ukulele"><fa-icon [icon]="show.ukulele ? fa.checked : fa.unchecked"></fa-icon>Ukulele</label>

<table class="table table-hover table-stripped"style="width:100%">
  <thead>
    <tr>
      <th [attr.colspan]="1+(show.guitar ? 2: 0) + (show.ukulele ? 2: 0)" *ngIf="show.maj">Major</th>
      <th [attr.colspan]="1+(show.guitar ? 2: 0) + (show.ukulele ? 2: 0)" *ngIf="show.min">Minor</th>
    </tr>
    <tr>
      <ng-container *ngIf="show.maj">
        <th></th>
        <ng-container *ngIf="show.guitar">
          <th colspan="1">Guitar</th>
          <th colspan="1">
            <select name="e_guitar" [(ngModel)]="extra.guitar.maj">
              <option *ngFor="let item of extras" [value]="item.value">{{item.title}}</option>
            </select>
          </th>
        </ng-container>
        <ng-container *ngIf="show.ukulele">
          <th colspan="1">Ukulele</th>
          <th colspan="1">
            <select name="e_guitar" [(ngModel)]="extra.ukulele.maj">
              <option *ngFor="let item of extras" [value]="item.value">{{item.title}}</option>
            </select>
          </th>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="show.min">
        <th></th>
        <ng-container *ngIf="show.guitar">
          <th colspan="1">Guitar</th>
          <th colspan="1">
            <select name="e_guitar" [(ngModel)]="extra.guitar.min">
              <option *ngFor="let item of extras" [value]="item.value">{{item.title}}</option>
            </select>
          </th>
        </ng-container>
        <ng-container *ngIf="show.ukulele">
          <th colspan="1">Ukulele</th>
          <th colspan="1">
            <select name="e_guitar" [(ngModel)]="extra.ukulele.min">
              <option *ngFor="let item of extras" [value]="item.value">{{item.title}}</option>
            </select>
          </th>
        </ng-container>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let note of notes">
      <ng-container *ngIf="show.maj">
        <td><a routerLink="/chords/{{note}}">{{note}}</a></td>
        <td *ngIf="show.guitar"><app-chord-render [chord]="note" instrument="guitar" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.guitar"><app-chord-render [chord]="note+extra.guitar.maj" instrument="guitar" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.ukulele"><app-chord-render [chord]="note" instrument="ukulele" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.ukulele"><app-chord-render [chord]="note+extra.ukulele.maj" instrument="ukulele" [graph]="true"></app-chord-render></td>
      </ng-container>
      <ng-container *ngIf="show.min">
        <td><a routerLink="/chords/{{note}}m">{{note}}m</a></td>
        <td *ngIf="show.guitar"><app-chord-render [chord]="note + 'm'" instrument="guitar" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.guitar"><app-chord-render [chord]="note + 'm' + extra.guitar.min" instrument="guitar" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.ukulele"><app-chord-render [chord]="note + 'm'" instrument="ukulele" [graph]="true"></app-chord-render></td>
        <td *ngIf="show.ukulele"><app-chord-render [chord]="note + 'm' + extra.ukulele.min" instrument="ukulele" [graph]="true"></app-chord-render></td>
      </ng-container>
    </tr>
  </tbody>
</table>

